import { render, staticRenderFns } from "./ReservationApp.vue?vue&type=template&id=19024c14"
import script from "./ReservationApp.vue?vue&type=script&lang=js"
export * from "./ReservationApp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports